/* nuo. theme — interacciones */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const cfg = window.nuo || {};

  /* ---------- Money ---------- */
  const formatMoney = (cents, format = cfg.moneyFormat || '${{amount}}') => {
    cents = Number(cents || 0);
    const fmt = (n, d, ts = ',', ds = '.') => {
      const [i, f] = (n / 100).toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(cents, 2),
      amount_no_decimals: fmt(cents, 0),
      amount_with_comma_separator: fmt(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_apostrophe_separator: fmt(cents, 2, "'", '.')
    }[k] ?? fmt(cents, 2)));
  };
  window.nuo.formatMoney = formatMoney;

  /* ---------- Reveal on scroll ---------- */
  const revealIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); revealIO.unobserve(e.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
  const initReveal = (root = document) => $$('[data-reveal]', root).forEach((el) => revealIO.observe(el));

  /* ---------- Header ---------- */
  const initHeader = () => {
    const wrap = $('.header-wrapper');
    if (!wrap) return;
    const onScroll = () => wrap.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const drawer = $('#MenuDrawer');
    $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { drawer?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
    $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { drawer?.classList.remove('is-open'); document.body.style.overflow = ''; }));
  };

  /* ---------- Announcement rotator ---------- */
  const initAnnouncement = () => {
    $$('[data-announcement]').forEach((bar) => {
      const items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      let i = 0;
      const speed = Number(bar.dataset.speed || 4) * 1000;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  };

  /* ---------- Countdown (se reinicia a medianoche local) ---------- */
  const initCountdown = () => {
    $$('[data-countdown]').forEach((el) => {
      const endAttr = el.dataset.end;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let end;
        if (endAttr) end = new Date(endAttr);
        if (!end || isNaN(end) || end < new Date()) { end = new Date(); end.setHours(24, 0, 0, 0); }
        const diff = Math.max(0, end - new Date());
        const h = Math.floor(diff / 36e5), m = Math.floor((diff % 36e5) / 6e4), s = Math.floor((diff % 6e4) / 1e3);
        $('[data-h]', el).textContent = pad(h);
        $('[data-m]', el).textContent = pad(m);
        $('[data-s]', el).textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  };

  /* ---------- Accordions animados ---------- */
  const initAccordions = (root = document) => {
    $$('details.accordion', root).forEach((d) => {
      const summary = $('summary', d), content = $('.accordion__content', d);
      if (!summary || !content || d.dataset.bound) return;
      d.dataset.bound = '1';
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.open) {
          content.animate([{ height: content.scrollHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => d.removeAttribute('open');
        } else {
          d.setAttribute('open', '');
          content.animate([{ height: '0px', opacity: 0 }, { height: content.scrollHeight + 'px', opacity: 1 }], { duration: 380, easing: 'cubic-bezier(.2,.8,.2,1)' });
        }
      });
    });
  };

  /* ---------- Sliders ---------- */
  const initSliders = (root = document) => {
    $$('[data-slider]', root).forEach((s) => {
      const track = $('.slider__track', s) || $('.gallery__track', s);
      const prev = $('[data-prev]', s), next = $('[data-next]', s);
      if (!track) return;
      const step = () => (track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + 14;
      const update = () => {
        if (prev) prev.disabled = track.scrollLeft < 5;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
      };
      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  };

  /* ---------- Galería de producto ---------- */
  const initGallery = (root = document) => {
    $$('[data-gallery]', root).forEach((g) => {
      const track = $('.gallery__track', g);
      const slides = $$('.gallery__slide', g);
      const thumbs = $$('.gallery__thumb', g);
      const go = (i) => { const sl = slides[i]; if (sl) track.scrollTo({ left: sl.offsetLeft, behavior: 'smooth' }); };
      thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
      $('[data-gallery-prev]', g)?.addEventListener('click', () => go(Math.max(0, cur() - 1)));
      $('[data-gallery-next]', g)?.addEventListener('click', () => go(Math.min(slides.length - 1, cur() + 1)));
      const cur = () => Math.round(track.scrollLeft / track.clientWidth);
      track.addEventListener('scroll', () => {
        const i = cur();
        thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
      }, { passive: true });
      g.goToMedia = (mediaId) => {
        const i = slides.findIndex((s) => s.dataset.mediaId == mediaId);
        if (i > -1) go(i);
      };
    });
  };

  /* ---------- Scroll-driven: capas y parallax ---------- */
  const initScrollFx = () => {
    const layers = $$('[data-layers]');
    const banners = $$('[data-parallax]');
    if (!layers.length && !banners.length) return;
    const progress = (el) => {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight;
      return Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
    };
    let ticking = false;
    const run = () => {
      layers.forEach((l) => {
        const p = progress(l);
        const spread = Math.sin(Math.min(1, p * 1.6) * Math.PI) ;
        const max = Number(l.dataset.max || 70);
        l.style.setProperty('--gap', (spread * max).toFixed(1) + 'px');
        l.style.setProperty('--label-o', Math.max(0, spread * 1.4 - 0.3).toFixed(2));
      });
      banners.forEach((b) => b.style.setProperty('--banner-scale', (1.15 - progress(b) * 0.15).toFixed(3)));
      ticking = false;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    run();
  };

  /* ---------- Reviews: ver más ---------- */
  const initReviews = () => {
    $$('[data-reviews-more]').forEach((btn) => btn.addEventListener('click', () => {
      const wrap = btn.closest('[data-reviews]');
      $$('.review.is-hidden', wrap).forEach((r) => { r.classList.remove('is-hidden'); r.classList.add('is-visible'); });
      btn.remove();
    }));
  };

  /* ---------- Carrito (drawer AJAX) ---------- */
  const Cart = {
    drawer: null,
    async fetch() { return (await fetch(cfg.routes.cart + '.js')).json(); },
    open() {
      if (cfg.cartType === 'page') { window.location.href = cfg.routes.cart; return; }
      this.drawer?.classList.add('is-open'); document.body.style.overflow = 'hidden';
    },
    close() { this.drawer?.classList.remove('is-open'); document.body.style.overflow = ''; },
    async add(items) {
      const res = await fetch(cfg.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'No se pudo agregar al carrito');
      await this.refresh();
      return data;
    },
    async change(key, quantity) {
      await fetch(cfg.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity })
      });
      await this.refresh();
    },
    async refresh() {
      const cart = await this.fetch();
      this.render(cart);
      return cart;
    },
    render(cart) {
      $$('[data-cart-count]').forEach((c) => {
        c.textContent = cart.item_count;
        c.hidden = cart.item_count === 0;
        c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
      });
      const d = this.drawer; if (!d) return;
      const items = $('[data-cart-items]', d);
      const foot = $('[data-cart-foot]', d);
      const empty = $('[data-cart-empty]', d);
      empty.hidden = cart.item_count > 0;
      foot.hidden = cart.item_count === 0;
      items.innerHTML = cart.items.map((it) => `
        <div class="cart-item">
          <a href="${it.url}" class="cart-item__img">${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="${(it.product_title || '').replace(/"/g, '&quot;')}" loading="lazy" width="72" height="72">` : ''}</a>
          <div>
            <a href="${it.url}" class="cart-item__title">${it.product_title}</a>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${it.variant_title}</div>` : ''}
            <div class="qty">
              <button type="button" aria-label="Quitar uno" data-qty="${it.key}" data-val="${it.quantity - 1}">−</button>
              <span>${it.quantity}</span>
              <button type="button" aria-label="Agregar uno" data-qty="${it.key}" data-val="${it.quantity + 1}">+</button>
            </div>
          </div>
          <div>
            <div class="cart-item__price">${formatMoney(it.final_line_price)}</div>
            ${it.original_line_price > it.final_line_price ? `<s class="muted" style="font-size:.78rem;display:block;text-align:right">${formatMoney(it.original_line_price)}</s>` : ''}
            <button type="button" class="cart-item__remove" data-qty="${it.key}" data-val="0">Eliminar</button>
          </div>
        </div>`).join('');
      $('[data-cart-total]', d).textContent = formatMoney(cart.total_price);
      // Barra de envío gratis
      const bar = $('[data-shipping-bar]', d);
      if (bar && cfg.freeShippingThreshold > 0) {
        const left = cfg.freeShippingThreshold - cart.total_price;
        const pct = Math.min(100, (cart.total_price / cfg.freeShippingThreshold) * 100);
        $('.shipping-bar__fill', bar).style.width = pct + '%';
        $('[data-shipping-text]', bar).innerHTML = left > 0
          ? `Te faltan <strong>${formatMoney(left)}</strong> para el envío gratis`
          : '🎉 ¡Tienes <strong>envío gratis</strong>!';
      }
    },
    init() {
      this.drawer = $('#CartDrawer');
      $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { if (cfg.cartType !== 'page') { e.preventDefault(); this.open(); } }));
      $$('[data-cart-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { this.close(); $('#MenuDrawer')?.classList.remove('is-open'); document.body.style.overflow = ''; } });
      this.drawer?.addEventListener('click', (e) => {
        const b = e.target.closest('[data-qty]');
        if (b) { b.disabled = true; this.change(b.dataset.qty, Number(b.dataset.val)); }
      });
      if (this.drawer) this.refresh();
    }
  };
  window.nuo.cart = Cart;

  /* ---------- Formularios genéricos de "agregar" (tarjetas) ---------- */
  const initQuickAdd = () => {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[data-quick-add]');
      if (!form || cfg.cartType === 'page') return;
      e.preventDefault();
      const btn = $('button[type=submit]', form);
      btn?.classList.add('is-loading');
      try { await Cart.add([{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }]); Cart.open(); }
      catch (err) { alert(err.message); }
      btn?.classList.remove('is-loading');
    });
  };

  /* ---------- Producto ---------- */
  const initProduct = (root = document) => {
    $$('[data-product]', root).forEach((p) => {
      const dataEl = $('script[data-product-json]', p);
      if (!dataEl) return;
      const product = JSON.parse(dataEl.textContent);
      const form = $('form[data-product-form]', p);
      const idInput = $('[name=id]', form);
      const btn = $('[data-add-button]', p);
      const btnLabel = $('.btn__label', btn);
      const priceEl = $('[data-price]', p);
      const compareEl = $('[data-compare]', p);
      const saveEl = $('[data-save]', p);
      const unitEl = $('[data-unit]', p);
      const errorEl = $('[data-error]', p);
      const gallery = $('[data-gallery]', p);
      const sticky = $('[data-sticky-atc]');
      const tiers = $$('[data-tier]', p);
      const upsell = $('[data-upsell] input', p);
      let qty = Number(tiers.find((t) => t.classList.contains('is-selected'))?.dataset.qty || 1);
      let discount = Number(tiers.find((t) => t.classList.contains('is-selected'))?.dataset.discount || 0);

      const selected = () => $$('[data-option-index]', p).map((group) => {
        const sel = $('.is-selected', group);
        return sel ? sel.dataset.value : null;
      });
      const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => opts[i] == null || o === opts[i]));
      let variant = product.variants.find((v) => v.id == idInput.value) || product.variants[0];

      const updateAvailability = () => {
        const opts = selected();
        $$('[data-option-index]', p).forEach((group) => {
          const idx = Number(group.dataset.optionIndex);
          $$('[data-value]', group).forEach((el) => {
            const test = [...opts]; test[idx] = el.dataset.value;
            const v = findVariant(test);
            el.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      };

      const render = () => {
        if (!variant) {
          btn.disabled = true; btnLabel.textContent = 'No disponible';
          sticky && ($('[data-add-button]', sticky).disabled = true);
          return;
        }
        idInput.value = variant.id;
        const unit = Math.round(variant.price * (1 - discount / 100));
        const total = unit * qty;
        const compareUnit = Math.max(variant.compare_at_price || 0, variant.price);
        if (priceEl) priceEl.textContent = formatMoney(unit);
        if (compareEl) { compareEl.textContent = formatMoney(compareUnit); compareEl.hidden = compareUnit <= unit; }
        if (saveEl) { const pct = Math.round((1 - unit / compareUnit) * 100); saveEl.textContent = `-${pct}%`; saveEl.hidden = pct <= 0; }
        if (unitEl) unitEl.hidden = qty <= 1;
        tiers.forEach((t) => {
          const q = Number(t.dataset.qty), d = Number(t.dataset.discount || 0);
          const tp = $('[data-tier-price]', t), tc = $('[data-tier-compare]', t);
          if (tp) tp.textContent = formatMoney(Math.round(variant.price * (1 - d / 100)) * q);
          if (tc) { tc.textContent = formatMoney(compareUnit * q); tc.hidden = compareUnit * q <= Math.round(variant.price * (1 - d / 100)) * q; }
        });
        btn.disabled = !variant.available;
        btnLabel.textContent = variant.available ? (btn.dataset.label || 'Agregar al carrito') : 'Agotado';
        $$('[data-option-index]', p).forEach((group) => {
          const lbl = $('[data-selected-label]', group);
          if (lbl) lbl.textContent = variant.options[Number(group.dataset.optionIndex)];
        });
        if (sticky) {
          $('[data-sticky-price]', sticky).textContent = formatMoney(total);
          $('[data-sticky-variant]', sticky).textContent = variant.title !== 'Default Title' ? variant.title : '';
          const sb = $('[data-add-button]', sticky); sb.disabled = !variant.available;
        }
        if (variant.featured_media && gallery?.goToMedia) gallery.goToMedia(variant.featured_media.id);
        if (p.dataset.updateUrl === 'true') {
          const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        updateAvailability();
      };

      $$('[data-option-index]', p).forEach((group) => {
        group.addEventListener('click', (e) => {
          const el = e.target.closest('[data-value]'); if (!el) return;
          $$('[data-value]', group).forEach((x) => { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
          el.classList.add('is-selected'); el.setAttribute('aria-checked', 'true');
          let v = findVariant(selected());
          if (!v) { // ajusta a la combinación disponible más cercana
            const idx = Number(group.dataset.optionIndex);
            v = product.variants.find((x) => x.options[idx] === el.dataset.value && x.available) || product.variants.find((x) => x.options[idx] === el.dataset.value);
            if (v) $$('[data-option-index]', p).forEach((g) => {
              const i = Number(g.dataset.optionIndex);
              $$('[data-value]', g).forEach((x) => x.classList.toggle('is-selected', x.dataset.value === v.options[i]));
            });
          }
          variant = v; render();
        });
      });

      tiers.forEach((t) => t.addEventListener('click', () => {
        tiers.forEach((x) => { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
        t.classList.add('is-selected'); t.setAttribute('aria-checked', 'true');
        qty = Number(t.dataset.qty || 1); discount = Number(t.dataset.discount || 0);
        render();
      }));

      const submit = async (button) => {
        if (cfg.cartType === 'page') { $('[name=quantity]', form).value = qty; form.submit(); return; }
        errorEl && (errorEl.hidden = true);
        button.classList.add('is-loading');
        const items = [{ id: variant.id, quantity: qty }];
        if (upsell?.checked && upsell.dataset.variantId) items.push({ id: Number(upsell.dataset.variantId), quantity: 1 });
        try { await Cart.add(items); Cart.open(); }
        catch (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } }
        button.classList.remove('is-loading');
      };
      form.addEventListener('submit', (e) => { e.preventDefault(); submit(btn); });
      if (sticky) {
        $('[data-add-button]', sticky).addEventListener('click', () => submit($('[data-add-button]', sticky)));
        const io = new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 });
        io.observe(btn);
      }
      render();
    });
  };

  /* ---------- Init ---------- */
  const init = (root = document) => {
    initReveal(root); initAccordions(root); initSliders(root); initGallery(root); initProduct(root);
  };
  document.addEventListener('DOMContentLoaded', () => {
    initHeader(); initAnnouncement(); initCountdown(); initScrollFx(); initReviews(); initQuickAdd();
    Cart.init(); init();
  });
  // Editor de temas
  document.addEventListener('shopify:section:load', (e) => { init(e.target); initCountdown(); initScrollFx(); initReviews(); });
})();
